import React from "react";
import { Link } from "react-router-dom";
import { gql } from "@apollo/client";

import { ListItem, ListItemAvatar, ListItemText, Avatar } from "@mui/material";

export default function UserListItem({ user, ...props }) {
  return (
    <ListItem
      dense
      divider
      button
      component={Link}
      to={`/admin/users/${user.id}`}
      {...props}
    >
      <ListItemAvatar>
        <Avatar src={user.profile.picture} />
      </ListItemAvatar>

      <ListItemText
        primary={user.profile.fullName}
        secondary={user.profile.email}
      />
    </ListItem>
  );
}

UserListItem.fragments = {
  user: gql`
    fragment UserListItem_User on User {
      id
      profile {
        picture
        fullName
        email
      }
    }
  `,
};
